import api from "./apiClient";
import API_ENDPOINTS from "../config/apiEndpoints";
import { extractSuccessStory } from "./dmsMasterService";

export const isApiSuccess = (response) => Number(response?.success) === 1;

export const extractUsersActivityList = (response) => {
  const direct = response?.data?.UsersActivity ?? response?.data?.usersActivity;
  if (Array.isArray(direct)) return direct;

  const fromDataset = extractSuccessStory(response, "UsersActivity");
  return Array.isArray(fromDataset) ? fromDataset : [];
};

export const fetchUserList = async ({ organizationId, staffId }) => {
  return api.post(API_ENDPOINTS.USER.GET_USERLIST, {
    OrganizationId: organizationId,
    StaffId: staffId,
    Action: "Get",
    AccessCode: "",
    Password: "",
    HaveProfileViewRights: 1,
    HaveProfileEditRights: 0,
    HaveDelegationLogViewRights: 1,
    HaveDelegationLogEditRights: 0,
    HavingLineManagerRights: 1,
    HaveStudyTaskArchiveRights: 0,
    CreatedBy: staffId,
  });
};

export const parseUserListResponse = (response) => {
  if (!isApiSuccess(response)) {
    return {
      ok: false,
      users: [],
      message:
        response?.message ||
        "We could not load the user list. Please refresh or contact your administrator.",
    };
  }

  return {
    ok: true,
    users: extractUsersActivityList(response),
    message: "",
  };
};

export const mapUsersForTable = (users = []) =>
  users.map((user) => ({
    ...user,
    IsCro: user?.IsCRO ?? user?.IsCro,
  }));
